// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3BSgz","name":"ConsentHeader_name__Uw2au","birthday":"ConsentHeader_birthday__3rOzo","skeleton":"ConsentHeader_skeleton__ybZlY"};